import {bootstrapApplication} from '@angular/platform-browser';
import {RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules} from '@angular/router';
import {IonicRouteStrategy, provideIonicAngular} from '@ionic/angular/standalone';
import {routes} from './app/app.routes';
import {AppComponent} from './app/app.component';
import {provideHttpClient, withInterceptors} from "@angular/common/http";
import {errorInterceptor} from "./app/interceptors/error.interceptor";
import {authInterceptor} from "./app/interceptors/auth.interceptor";
import {ApiConfiguration} from "./app/api/api-configuration";
import {environment} from "./environments/environment";
import {loadingInterceptor} from "./app/interceptors/loading.interceptor";
import {clearToastInterceptor} from "./app/interceptors/clear-toast.interceptor";
import {connectionUnavailableInterceptor} from "./app/interceptors/connection-unavailable.interceptor";
import {serviceUnavailableInterceptor} from "./app/interceptors/service-unavailable.interceptor";
import {registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {LOCALE_ID, provideZoneChangeDetection} from '@angular/core';
import {getMessaging, provideMessaging} from "@angular/fire/messaging";
import {initializeApp, provideFirebaseApp} from "@angular/fire/app";
import './app/shared/smzh-kit/register-smzh-kit';

registerLocaleData(localeDe);

bootstrapApplication(AppComponent, {
  providers: [
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideMessaging(() => getMessaging()),
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    provideIonicAngular({
      rippleEffect: false,
      mode: 'md'
    }),
    provideZoneChangeDetection(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors([authInterceptor, connectionUnavailableInterceptor, serviceUnavailableInterceptor, errorInterceptor, loadingInterceptor, clearToastInterceptor])),
    {
      provide: ApiConfiguration,
      useFactory: () => {
        const config = new ApiConfiguration();
        config.rootUrl = environment.apiUrl;
        return config;
      }
    },
    // 👇 This sets the default locale for the whole app
    {provide: LOCALE_ID, useValue: 'de-DE'}]
});
